module.exports = __webpack_public_path__ + "static/media/ICT4U_3.de9a89c5.jpeg";